// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";

// function DailyRatesPopup() {
//   // Function to get current date in YYYY-MM-DD format
//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // Function to get current time in HH:MM format
//   const getCurrentTime = () => {
//     const now = new Date();
//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     return `${hours}:${minutes}`;
//   };

//   const navigate = useNavigate();
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);
//   const [addData, setAddData] = useState({
//     gold_1g_rate: "",
//     cold_coin_rate: "",
//     gold_pure_percentage: "",
//     silver_1g_rate: "",
//     silver_coin_rate: "",
//     silver_pure_percentage: "",
//     date: getCurrentDate(),
//     time: getCurrentTime(),
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//   });

//   const handlesubmit = async (e) => {
//     e.preventDefault();

//     // Basic validation
//     if (
//       !addData.gold_1g_rate ||
//       !addData.cold_coin_rate ||
//       !addData.gold_pure_percentage ||
//       !addData.silver_1g_rate ||
//       !addData.silver_coin_rate ||
//       !addData.silver_pure_percentage
//     ) {
//       toast.error("Please fill in all required fields", 3000, "topRight");
//       return;
//     }

//     try {
//       setLoading(true);
//       // Format the date: from "YYYY-MM-DD" to "DD-MM-YYYY"
//       const inputDate = addData.date;
//       const formattedDate = inputDate
//         ? inputDate.split("-").reverse().join("-")
//         : getCurrentDate();

//       const formData = {
//         gold_1g_rate: addData.gold_1g_rate,
//         cold_coin_rate: addData.cold_coin_rate,
//         gold_pure_percentage: addData.gold_pure_percentage,
//         silver_10g_rate: addData.silver_1g_rate,
//         silver_coin_rate: addData.silver_coin_rate,
//         silver_pure_percentage: addData.silver_pure_percentage,
//         date: formattedDate,
//         time: addData.time.trim() || getCurrentTime(),
//         created_by: addData.created_by || "",
//         created_date: getCurrentDate(),
//       };
//       console.log("Submit formData:", formData);

//       const response = await axios.post(
//         `${ApiUrl}/Api/daily_rates.php`,
//         formData
//       );

//       console.log("Submit data:", response.data);
//       navigate("/dashboard");
//       toast.success("Added Successfully!", 3000, "topRight");

//       // Reset form
//       setAddData({
//         gold_1g_rate: "",
//         cold_coin_rate: "",
//         gold_pure_percentage: "",
//         silver_1g_rate: "",
//         silver_coin_rate: "",
//         silver_pure_percentage: "",
//         date: getCurrentDate(),
//         time: getCurrentTime(),
//         created_by: "",
//         created_date: "",
//         updated_by: "",
//         updated_date: "",
//       });
//     } catch (error) {
//       console.error("Error updating data:", error.message);
//       toast.error("Failed to Add Data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container mt-5 p-5">
//         <div className="card">
//           <div className="card-header d-flex align-items-center">
//             <h6 className="text-primary mb-0">Add Daily Rates</h6>
//           </div>
//           <div className="card-body">
//             <form onSubmit={handlesubmit}>
//               <div className="row">
//                 <div className="col-lg-4">
//                   <div className="mb-3">
//                     <label htmlFor="gold_1g_rate" className="form-label">
//                       Gold 1g Rate
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       id="gold_1g_rate"
//                       name="gold_1g_rate"
//                       placeholder="Enter Gold 1g Rate"
//                       value={addData.gold_1g_rate}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                           setAddData({ ...addData, gold_1g_rate: value });
//                         }
//                       }}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="cold_coin_rate" className="form-label">
//                       Gold Coin Rate
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       id="cold_coin_rate"
//                       name="cold_coin_rate"
//                       placeholder="Enter Gold Coin Rate"
//                       value={addData.cold_coin_rate}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                           setAddData({
//                             ...addData,
//                             cold_coin_rate: e.target.value,
//                           });
//                         }
//                       }}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label
//                       htmlFor="gold_pure_percentage"
//                       className="form-label"
//                     >
//                       Gold Pure Percentage
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       id="gold_pure_percentage"
//                       name="gold_pure_percentage"
//                       placeholder="Enter Gold Pure Percentage"
//                       value={addData.gold_pure_percentage}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         // Allow only 0–100 integers
//                         if (
//                           /^\d{0,3}$/.test(value) &&
//                           (value === "" || Number(value) <= 100)
//                         ) {
//                           setAddData({
//                             ...addData,
//                             gold_pure_percentage: value,
//                           });
//                         }
//                       }}
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="col-lg-4">
//                   <div className="mb-3">
//                     <label htmlFor="silver_1g_rate" className="form-label">
//                       Silver 1g Rate
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="silver_1g_rate"
//                       name="silver_1g_rate"
//                       placeholder="Enter Silver 1g Rate"
//                       value={addData.silver_1g_rate}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                           // only digits allowed
//                           setAddData({
//                             ...addData,
//                             silver_1g_rate: value,
//                           });
//                         }
//                       }}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="silver_coin_rate" className="form-label">
//                       Silver Coin Rate
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       id="silver_coin_rate"
//                       name="silver_coin_rate"
//                       placeholder="Enter Silver Coin Rate"
//                       value={addData.silver_coin_rate}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                           setAddData({
//                             ...addData,
//                             silver_coin_rate: value,
//                           });
//                         }
//                       }}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label
//                       htmlFor="silver_pure_percentage"
//                       className="form-label"
//                     >
//                       Silver Pure Percentage
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       id="silver_pure_percentage"
//                       name="silver_pure_percentage"
//                       placeholder="Enter Silver Pure Percentage"
//                       value={addData.silver_pure_percentage}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (
//                           /^\d{0,3}$/.test(value) &&
//                           (value === "" || Number(value) <= 100)
//                         ) {
//                           setAddData({
//                             ...addData,
//                             silver_pure_percentage: value,
//                           });
//                         }
//                       }}
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="col-lg-4">
//                   <div className="mb-3">
//                     <label htmlFor="date" className="form-label">
//                       Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       id="date"
//                       name="date"
//                       value={addData.date}
//                       onChange={(e) =>
//                         setAddData({ ...addData, date: e.target.value })
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="time" className="form-label">
//                       Time
//                     </label>
//                     <input
//                       type="time"
//                       className="form-control"
//                       id="time"
//                       name="time"
//                       value={addData.time}
//                       onChange={(e) =>
//                         setAddData({ ...addData, time: e.target.value })
//                       }
//                       required
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="text-center mt-4">
//                 <button type="submit" className="btn btn-primary btn-sm px-4">
//                   Submit
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default DailyRatesPopup;


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Toast/ToastContext";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";

function DailyRatesPopup() {
  // Function to get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Function to get current time in HH:MM format
  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [addData, setAddData] = useState({
    gold_1g_rate: "",
    cold_coin_rate: "",
    gold_pure_percentage: "",
    silver_1g_rate: "",
    silver_coin_rate: "",
    silver_pure_percentage: "",
    date: getCurrentDate(),
    time: getCurrentTime(),
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !addData.gold_1g_rate ||
      !addData.cold_coin_rate ||
      !addData.gold_pure_percentage ||
      !addData.silver_1g_rate ||
      !addData.silver_coin_rate ||
      !addData.silver_pure_percentage
    ) {
      toast.error("Please fill in all required fields", 3000, "topRight");
      return;
    }

    try {
      setLoading(true);
      // Format the date: from "YYYY-MM-DD" to "DD-MM-YYYY"
      const inputDate = addData.date;
      const formattedDate = inputDate
        ? inputDate.split("-").reverse().join("-")
        : getCurrentDate();

      const formData = {
        gold_1g_rate: addData.gold_1g_rate,
        cold_coin_rate: addData.cold_coin_rate,
        gold_pure_percentage: addData.gold_pure_percentage,
        silver_10g_rate: addData.silver_1g_rate,
        silver_coin_rate: addData.silver_coin_rate,
        silver_pure_percentage: addData.silver_pure_percentage,
        date: formattedDate,
        time: addData.time.trim() || getCurrentTime(),
        created_by: addData.created_by || "",
        created_date: getCurrentDate(),
      };
      console.log("Submit formData:", formData);

      const response = await axios.post(
        `${ApiUrl}/Api/daily_rates.php`,
        formData
      );

      console.log("Submit data:", response.data);
      navigate("/dashboard");
      toast.success("Added Successfully!", 3000, "topRight");

      // Reset form
      setAddData({
        gold_1g_rate: "",
        cold_coin_rate: "",
        gold_pure_percentage: "",
        silver_1g_rate: "",
        silver_coin_rate: "",
        silver_pure_percentage: "",
        date: getCurrentDate(),
        time: getCurrentTime(),
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      });
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to Add Data", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container mt-5 p-5">
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <h6 className="text-primary mb-0">Add Daily Rates</h6>
          </div>
          <div className="card-body">
            <form onSubmit={handlesubmit}>
              <div className="row">
                <div className="col-lg-4">
                  <div className="mb-3">
                    <label htmlFor="gold_1g_rate" className="form-label">
                      Gold 1g Rate
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      // pattern="[0-9]*"
                      className="form-control"
                      id="gold_1g_rate"
                      name="gold_1g_rate"
                      placeholder="Enter Gold 1g Rate"
                      value={addData.gold_1g_rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          setAddData({ ...addData, gold_1g_rate: value });
                        }
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="cold_coin_rate" className="form-label">
                      Gold Coin Rate
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      // pattern="[0-9]*"
                      className="form-control"
                      id="cold_coin_rate"
                      name="cold_coin_rate"
                      placeholder="Enter Gold Coin Rate"
                      value={addData.cold_coin_rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          setAddData({
                            ...addData,
                            cold_coin_rate: e.target.value,
                          });
                        }
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="gold_pure_rate" className="form-label">
                      Gold Pure Rate
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="gold_pure_rate"
                      name="gold_pure_rate"
                      placeholder="Enter Gold Pure Rate"
                      value={addData.gold_pure_percentage}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {   // ✅ only allow numbers
                          setAddData({
                            ...addData,
                            gold_pure_percentage: value,
                          });
                        }
                      }}
                      required
                    />
                  </div>

                </div>
                <div className="col-lg-4">
                  <div className="mb-3">
                    <label htmlFor="silver_1g_rate" className="form-label">
                      Silver 1g Rate
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="silver_1g_rate"
                      name="silver_1g_rate"
                      placeholder="Enter Silver 1g Rate"
                      value={addData.silver_1g_rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          // only digits allowed
                          setAddData({
                            ...addData,
                            silver_1g_rate: value,
                          });
                        }
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="silver_coin_rate" className="form-label">
                      Silver Coin Rate
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      // pattern="[0-9]*"
                      className="form-control"
                      id="silver_coin_rate"
                      name="silver_coin_rate"
                      placeholder="Enter Silver Coin Rate"
                      value={addData.silver_coin_rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          setAddData({
                            ...addData,
                            silver_coin_rate: value,
                          });
                        }
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="silver_pure_rate" className="form-label">
                      Silver Pure Rate
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="silver_pure_rate"
                      name="silver_pure_rate"
                      placeholder="Enter Silver Pure Rate"
                      value={addData.silver_pure_percentage}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {   
                          setAddData({
                            ...addData,
                            silver_pure_percentage: value,
                          });
                        }
                      }}
                      required
                    />
                  </div>

                </div>
                <div className="col-lg-4">
                  <div className="mb-3">
                    <label htmlFor="date" className="form-label">
                      Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="date"
                      name="date"
                      value={addData.date}
                      onChange={(e) =>
                        setAddData({ ...addData, date: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="time" className="form-label">
                      Time
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      id="time"
                      name="time"
                      value={addData.time}
                      onChange={(e) =>
                        setAddData({ ...addData, time: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <button type="submit" className="btn btn-primary btn-sm px-4">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default DailyRatesPopup;
